import { createSelector } from "reselect";
import { AppState } from "../reducer";

const getUser = (state: AppState) => {
  return state.user;
};

const getUserInfo = (state: AppState) => {
  return state.user.userInfo;
};

const getAuths = (state: AppState) => {
  return state.user.auths;
};

const getAdminUsers = (state: AppState) => {
  return state.user.adminUsers
};

const getAdminUsersLoading = (state: AppState) => {
  return state.user.adminUsersLoading
};

const getDepartments = (state: AppState) => {
  return state.user.departments
}

const getLinkedAccounts = (state: AppState) => {
  return state.user.linkedAccounts
}

export const getUserSelector = createSelector(getUser, (user) => user);

export const getUserInfoSelector = createSelector(getUserInfo, (userInfo) => userInfo);

export const getAuthSelector = createSelector(getAuths, (auths) => auths);

export const getAdminUsersSelector = createSelector(getAdminUsers, (admins) => admins);

export const getAdminUsersLoadingSelector = createSelector(getAdminUsersLoading, (adminUsersLoading) => adminUsersLoading);

export const getDepartmentsSelector = createSelector(getDepartments, (departments) => departments);

export const getLinkedAccountsSelector = createSelector(getLinkedAccounts, (linkedAccounts) => linkedAccounts);
